import { useNavigate } from 'react-router-dom';

import Permission from '../../assets/images/permission.gif';
import MyButton from '../../shared-components/button/Button';

/**
 * PermissionDenied component renders a message indicating that the user
 * does not have the required permissions to access a specific resource or page.
 *
 * This component is useful for notifying users about restricted access areas
 * within the application.
 * @returns {JSX.Element} The rendered component showing a "Permission Denied" message.
 */
function PermissionDenied() {
  const navigate = useNavigate();
  return (
    <div className="forbidden-error-main-page">
      <div className="image-container">
        <img src={Permission} alt="permission" />
      </div>
      <div className="content-container">
        <h3> Sorry, Permission Denied</h3>
        <p>You don&#39;t have access to view this page</p>
        <div className="content-btn">
          <MyButton
            label="Take me to home"
            buttonType="submit"
            onClickFunc={() => navigate('/')}
            disableHoverEffect
          />
        </div>
      </div>
    </div>
  );
}

export default PermissionDenied;
